import type { FaireProductEntity } from "../../entity_types/product";

export const p_wmpz6v9sud: FaireProductEntity = {
  token: "p_wmpz6v9sud",
  type: "product",
  name: "LE GRAND EUPHORIA",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/cf66f0da4a4e14fc0b0149570501936e1c80473155911ce57dcd6487f1abfe8e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa02a15d3f6327b81f29351f07c5c54256a65fd8c9504b1864d43537c37df49c.jpeg"
  ],
  priceDollars: 30,
  description: "Meet our new Le Grand Euphoria, 14 oz of your favorite scent is finally here!\n\nThe euphoric scent of spring time in the Silver Lake neighborhood of Los Angeles. Blooming bougainvillea cascades along fences while the gorgeous bouquet of night blooming jasmine and osmanthus fill the air. Balanced with exotic white musk and soft undertones of vanilla, this is a floral for both floral lovers and non-floral lovers alike.\n\nstar jasmine, lily, osmanthus, white musk, greens\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn. We use lead-free cotton wicks and premium fragrance oils. All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n14 ounces (397g), comes in our signature pink box.",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:11.069Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
